import {Injectable} from 'ng-metadata/core';
import {OpacService} from './opac.service';
import {RequestService} from './request/request.service';

import {getVid} from '../../../../appConfig/appConfigForward';

@Injectable()
export class ServiceButtonService {
    
    constructor(private opacService:OpacService, private requestService:RequestService) {
    }
    
	public makeIlsRequest(service, requestParameters){
		let _this = this;
        if (!requestParameters) {
            requestParameters = {};
        }
        requestParameters.vid = getVid();
		return this.opacService.makeIlsCall(service, requestParameters, 'GET')
				.then((res) => {
                    _this.requestService.setupNewForm(service, res);
                    _this.requestService.requestIsLoading = false;
					return res;
				},(res) => {
                    _this.requestService.displayErrorMessage = true;
                    _this.requestService.requestIsLoading = false;
                });
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/serviceButton.service.ts